import SurveyValue from './SurveyValue'

class SurveyNumber extends SurveyValue {
  static keyToObject(key) {
    return new SurveyNumber(key)
  }
}

export default SurveyNumber
